import { useContext } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { color } from 'ui';

import {
  AccountIcon,
  AccountIconActive,
  CollapseIcon,
  DashboardIcon,
  DashboardIconActive,
  ExpandIcon,
  LogoutIcon,
  TestIcon,
  TestIconActive,
} from '../assets/images/svgs';
import AppText from '../shared/AppText';
import { LayoutContext } from '../contexts/LayoutContext';

interface SideBarProps {
  active: string | undefined;
}
interface ContainerProps {
  collapsed: boolean;
}

interface MenuData {
  name: string;
  icon: JSX.Element;
  iconActive: JSX.Element;
  route: string;
}

interface IconDivProps {
  active: boolean;
}

const topMenuItems = [
  {
    name: 'Dashboard',
    icon: <DashboardIcon />,
    iconActive: <DashboardIconActive />,
    route: '/dashboard',
  },
  {
    name: 'Test',
    icon: <TestIcon />,
    iconActive: <TestIconActive />,
    route: '/test-management',
  },
  // {
  //   name: 'Notifications',
  //   icon: <NotificationIcon />,
  //   iconActive: <></>,
  //   route: '',
  // },
];
const bottomMenuItems = [
  {
    name: 'Account',
    icon: <AccountIcon />,
    iconActive: <AccountIconActive />,
    route: '/account-settings',
  },
  {
    name: 'Logout',
    icon: <LogoutIcon />,
    iconActive: <DashboardIconActive />,
    route: '',
  },
];

const Sidebar = ({ active = 'Dashboard' }: SideBarProps) => {
  const navigate = useNavigate();
  const { collapsed, setCollapsed } = useContext(LayoutContext);

  const handleCollapse = () => {
    setCollapsed((prev: boolean) => !prev);
  };

  const handleClick = (item: MenuData) => {
    navigate(item.route);
  };
  const handleSignOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/login');
  };

  return (
    <Container collapsed={collapsed}>
      <Collapsible onClick={handleCollapse}>
        {collapsed ? <ExpandIcon /> : <CollapseIcon />}
      </Collapsible>
      <TopMenu>
        <InnerMenu>
          {topMenuItems.map((item: MenuData) => (
            <Menu key={item.name} onClick={() => handleClick(item)}>
              <IconDiv active={item.name == active}>
                {item.name == active ? item.iconActive : item.icon}
              </IconDiv>
              {!collapsed && (
                <AppText
                  weight="400"
                  size="14px"
                  color={item.name == active ? color.primary : color.black}
                >
                  {item.name}
                </AppText>
              )}
            </Menu>
          ))}
        </InnerMenu>
      </TopMenu>

      <Bottom>
        <BottomMenu>
          {bottomMenuItems.map((item: MenuData) => (
            <Menu
            key={item.name}
              onClick={
                item.name == 'Logout' ? handleSignOut : () => handleClick(item)
              }
            >
              <IconDiv active={item.name == active}>
                {' '}
                {item.name == active ? item.iconActive : item.icon}
              </IconDiv>
              {!collapsed && (
                <AppText
                  weight="400"
                  size="14px"
                  color={item.name == active ? color.primary : color.black}
                >
                  {item.name}
                </AppText>
              )}
            </Menu>
          ))}
        </BottomMenu>
        {/* <BottomCard>
          <SkillDormLogo />
          <AppText display="block" weight="600" size="15px" color=" #1B2124">
            Expand your Horizon
          </AppText>
          <AppText display="block" weight="800" size="15px" color=" #1B2124">
            #For less
          </AppText>
          <CredusButton variant="dark">Learn more</CredusButton>
        </BottomCard> */}
      </Bottom>
    </Container>
  );
};

export default Sidebar;

const Container = styled.div<ContainerProps>`
  width: ${({ collapsed }) => (collapsed ? '70px' : '292px')};
  height: 100vh;
  background: #fff;
  position: fixed;
  padding-top: 136px;
  padding-bottom: 2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border: 2px solid rgba(224, 222, 247, 0.5);
  z-index: 100;
  border-right: 1px solid rgba(0, 9, 41, 0.15);
  transition: width 0.3s ease-out;
`;

const IconDiv = styled.div<IconDivProps>`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: ${(props) => (props.active ? '#fff5f3' : 'none')};
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  &:hover ${IconDiv} {
    background: #fff5f3;
  }
`;

const InnerMenu = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  gap: 2rem;
`;

const TopMenu = styled.div`
  padding-top: 2rem;
  display: flex;
`;

const Bottom = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 3rem;
  gap: 2rem;
  border-top: 1px solid rgba(224, 222, 247, 0.5);
`;

const BottomMenu = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

const Collapsible = styled.div`
  position: absolute;
  top: 100px;
  right: 1rem;
  cursor: pointer;
`;

// const BottomCard = styled.div`
//   display: flex;
//   background: #f6f6f6;
//   flex-direction: column;
//   align-items: center;
//   gap: 0.5rem;
//   padding-top: 1rem;
//   padding-bottom: 0.5rem;
//   /* box-sizing: border-box; */
//   radius: 5px;
//   height: 170px;
//   border-radius: 5px;
//   border: 0.4px solid #cdcccc;
//   width: 100%;
// `;
